<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
            <el-form-item label="用户名" prop="username">
                <el-input v-model="searchForm.username" placeholder="请输入用户名" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="昵称" prop="nickname">
                <el-input v-model="searchForm.nickname" placeholder="请输入昵称" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="d-flex justify-content-left" style="padding-bottom: 10px;">
            <el-button type="primary" style="width: 100px;" @click="addUser">添加</el-button>
        </div>

        <el-table stripe size="small " :data="userList" style="width: 100%" border>
            <el-table-column type="index" label="序号" width="60" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
            <el-table-column prop="username" label="用户名" width="200"></el-table-column>
            <el-table-column prop="nickname" label="昵称" width="150">
            </el-table-column>
            <el-table-column prop="userType" label="用户类型" width="200">
                <template slot-scope="{ row }">
                    <el-tag>{{row.typeDesc }}</el-tag>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="role" label="电话">
            </el-table-column> -->
            <el-table-column prop="parentUser" label="上级用户" width="150">
            </el-table-column>
            <el-table-column prop="phone" label="电话" width="150">
            </el-table-column>
            <el-table-column label="操作" width="240" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="handleCheck(scope.$index, scope.row)">查看
                    </el-button>
                    <el-button type="text" size="mini"  @click="handleModify(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type="text" style="color: #F56C6C;" size="mini" @click="handleDelete(scope.$index, scope.row)">删除
                    </el-button>

                    <el-dropdown trigger="click" @command="$event => handleCommand($event, scope.row)" style="margin-left: 10px;">
                        
                        <el-button type="text"><i class="el-icon-more" style="font-size: 16px;"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="oneKeyLogin">一键登录</el-dropdown-item>
                            <el-dropdown-item command="unBindWx" v-if="scope.row.hasWxUserBind == 1">解绑微信</el-dropdown-item>
                            <el-dropdown-item command="resetPwd">密码重置</el-dropdown-item>
                            <el-dropdown-item command="authHotel">授权酒店</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>


        <el-pagination class="mb-15" background @current-change="handleCurrentChange" @prev-click="prevPage"
            @next-click="nextPage" layout="prev, pager, next" :total="total">
        </el-pagination>


        <!-- 弹出框 -->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="500px">
             <el-form ref="form" :model="form" inline label-width="90px" size="small" :rules="formValidate" :disabled="userValue == 'check'">
                <el-form-item label="用户名" prop="username">
                    <el-input type="text" v-model="form.username" clearable placeholder="请输入用户名" style="width: 280px"/>
                </el-form-item>
                <el-form-item label="昵称" prop="nickname">
                    <el-input style="width: 280px;" placeholder="请输入昵称" v-model="form.nickname"
                        :disabled="userValue == 'check'" clearable>
                    </el-input>
                </el-form-item>
               
                <el-form-item label="用户类型" prop="userType">
                    <el-select v-model="form.userType" multiple placeholder="请选择" style="width: 280px;">
                        <el-option v-for="item in builtRoleList" :key="item.name" :label="item.roleDesc" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="角色" prop="roleIdList">
                    <el-select v-model="form.roleIdList" multiple placeholder="请选择" style="width: 280px;">
                        <el-option v-for="item in cumRoleList" :key="item.id" :label="item.roleDesc" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="上级用户" prop="parentUser">
                    <el-select v-model="form.parentUser" placeholder="请选择" style="width: 280px;" filterable remote :remote-method="remoteMethod" :loading="loading">
                        <el-option v-for="(item,key) in subUserList" :key="key" :label="item.username" :value="item.username">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input style="width: 280px;" placeholder="请输入手机号" v-model="form.phone" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" v-if="!form.id">
                    <el-input type="password" style="width: 280px;" placeholder="请输入用户密码" v-model="form.password" clearable>
                    </el-input>
                </el-form-item>
            </el-form>
          
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm('form')" v-if="userValue != 'check'">确 定</el-button>
            </span>
        </el-dialog>


        <!-- 密码重置  -->
        <ModifyPwdComponent :isPwd="isPwd" :userId="this.form.id" @close="isPwd = false" @comfirm="handelUpdateData"/>
        <!-- 授权酒店 -->
        <AuthHotelComponentut :isBind="isBind" :httpConfig="httpConfig" :propsData="{username: form.username}" :showCode="true"  @close="isBind = false"/>
    </div>
</template>

<script>
import { get, post, getMenuList, getButtonList } from "@/utils/request";

import _ from "lodash";
import ModifyPwdComponent from "./userComponent/modifyPwdComponent.vue";
import AuthHotelComponentut from "@/components/authHotelComponent/index.vue";

export default {
    name: "userManage",
    components: {
        ModifyPwdComponent,
        AuthHotelComponentut
    },
    data() {
        const validatePhone = (rule, value, callback) => {
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!reg.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        }
        return {
            searchForm: {
                username: undefined,
                nickname: undefined,
                pageNumber: 1,
                pageSize: 10
            },
            builtRoleList: [],
            cumRoleList: [],
            userList: [],
            total: 0,
            title: '',
            userValue: '',
            dialogVisible: false,
            tempPassword: undefined,
            form: {
                id: '',
                userType: [],
                roleIdList: [],
                parentUser: "",
                nickname: '',
                username: undefined,
                phone: undefined,
                password: undefined
            },
            formValidate: {
                username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
                nickname: [{ required: true, message: "请输入昵称", trigger: "blur" }],
                userType: [{ required: true, type: 'array', message: "请选择用户类型", trigger: "blur" }],
                // roleIdList: [{ required: true,type: 'array', message: "请选择角色", trigger: "blur" }],
                parentUser: [{ required: true,  message: "请选择上级用户", trigger: "blur" }],
                phone: [ { required: true, validator: validatePhone, trigger: 'blur' }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
            },
            loading: false,
            subUserList: [],

            isPwd: false,

            httpConfig:{
                getHotel: "/api/user/getUserBingHotels",//get获取已绑定的酒店列表
                selectHotel: "/api/hotel/page",//get获取要绑定的酒店列表
                bindHotel: "/api/user/bindHotels",//postRequest绑定
                unbindHotel:"/api/user/unBindHotels"
            },
            isBind: false
        }
    },
    methods: {
        handelUpdateData() {
            this.isPwd = false;
            this.userListRequest();
        },
        handleCommand(command,row) {
            this.form = row;
            switch (command) {
                case "oneKeyLogin":
                    this.handleOneKeyLogin(row);
                    break;
                case "unBindWx":
                    this.handleUnBindWx(row);
                    break;
                case "resetPwd":
                    this.isPwd = true;
                    break;
                case "authHotel":
                    this.isBind = true;
                    break;
            
                default:
                    break;
            }
        },
        handleOneKeyLogin(item) {
            this.postRequest(`/api/user/oneClickLogin?id=${item.id}`)
            .then(res => {
                const data = res.data;
                if (data.code == 200) {
                    if (data.data.token && data.data.userInfo.id) {
                        // 将token及用户id存放到Vuex中
                        this.$store.commit('SAVE_TOKEN', data.data.token)
                        this.$store.commit('SAVE_USER_ID', data.data.userInfo.id)
                        this.$store.commit('SET_MENU_LIST', data.data.menuList)
                        
                        getMenuList();
                        getButtonList(this, "refresh");
                        this.getUserInfo();
                        

                        this.$router.push("/index")
                    }
                }
            })
        },
        getUserInfo() {
            this.userId = localStorage.getItem('userId')
            get('/api/user/get/' + this.userId)
                .then(res => {
                    let data = res.data;
                    if(data.code == 200) {
                        this.$store.commit("UPDATE_USERINFO",data.data)
                    }
                })
                .catch(err => {
                    // console.log(err);
                })
        },
        handleUnBindWx(item) {
            this.$confirm('确认解除该微信绑定, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.putRequest(`/api/user/unBindRelateWx?username=${item.username}`)
                .then(res => {
                    let data = res.data;
                    if(data.code == 200) {
                        this.$message.success(data.msg);
                        this.getTableData();
                    } else {
                        this.$message.warning(data.msg);
                    }
                })
            });
        },
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                this.getRequest(`/api/user/findSubUserLikeName?searchName=${query}`)
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if(data.code == 200) {
                        this.subUserList = data.data;
                    }
                }).catch(err => {
                    this.loading = false;

                })
            } else {
                this.subUserList = [];
            }
        },
        //获取用户列表
        handleSearch() {
           this.searchForm.pageNumber = 1;
            //获取用户列表
            this.userListRequest()
        },
        handleReset() {
            this.searchForm = {
                username: undefined,
                nickname: undefined,
                pageNumber: 1,
                pageSize: 10
            };

            this.userListRequest();
        },

        //获取用户列表请求
        userListRequest() {
            get('/api/user/page', this.searchForm)
                .then(res => {
                    // console.log(res);
                    this.userList = res.data.data.records
                    this.total = res.data.data.total
                })
                .catch(err => {
                    console.log(err);
                })
        },

        //删除用户方法
        handleDelete(index, row) {
            this.$confirm('确认该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                get('/api/user/delete/' + row.id)
                .then(res => {
                    // console.log(res);
                    let data = res.data;
                    if(res.code == 200) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000
                        });
                        setTimeout(() => {
                            this.userListRequest();
                        }, 1000)
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            }).catch(() => {
                          
            });
           
        },

        getRoleList() {
            this.getRequest("/role/getRoleListByRoleType").then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.builtRoleList = data.data.filter(item => item.roleType == 0);
                    this.cumRoleList = data.data.filter(item => item.roleType == 1);
                }
            })
        },

        //增加用户方法
        addUser() {
            this.form = {
                userType: [],
                roleIdList: [],
                parentUser: "",
            }
            this.dialogVisible = true
            this.title = '添加用户'
            this.userValue = 'add'
        },

        handleCheck(index, row) {
            this.userValue = 'check'
            this.dialogVisible = true
            this.title = '查看用户信息'
            let data = _.cloneDeep(row);
            // console.log(data);

            data.userType = data.userType ? data.userType.split(",") : [];
            this.form = data;
        },

        //修改用户信息
        handleModify(index, row) {
            // console.log(index);
            let data = _.cloneDeep(row);
            console.log(data);

            data.userType = data.userType ? data.userType.split(",") : [];
            this.form = data;
            this.tempPassword = this.form.password
            this.dialogVisible = true
            this.title = '修改用户信息'
            this.userValue = 'modify';
        },

        //
        confirm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    let data = _.cloneDeep(this.form);
                    data.userType = data.userType.join(",");
                    this.userRequest(data)
                }
            })
            // let value = this.userValue
            // let data = {
            //     id: undefined,
            //     userType: this.form.userType,
            //     roleIdList: this.form.roleIdList,
            //     nickname: this.form.nickname,
            //     username: this.form.username,
            //     phone: this.form.phone,
            //     password: this.form.password
            // }
            // if (value == 'add') {
            //     this.userRequest(value, data)
            // } else if (value == 'modify') {
            //     data.id = this.form.id
            //     if (this.tempPassword == this.form.password) {
            //         this.form.password = undefined
            //     }
            //     // data.deptId = this.deptId
                // this.userRequest(value)
            // }
        },

        //请求方法
        userRequest(data) {
            post('/api/user/' + this.userValue, data)
                .then(res => {
                    // console.log(res);
                    if (res.data.code === "200") {
                        this.$message({
                            message: '操作成功！',
                            type: 'success',
                            duration: 1000
                        });
                        this.dialogVisible = false;
                        this.handleSearch();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'warning',
                            duration: 1000
                        });

                    }
                })
                .catch(err => {
                    console.log(err);
                })
        },

        //选择页码
        handleCurrentChange(num) {
            this.searchForm.pageNumber = num;
            this.userListRequest()
        },

        //上一页
        prevPage(num) {
            this.searchForm.pageNumber = num;

            this.userListRequest()

        },

        //下一页
        nextPage(num) {
            this.searchForm.pageNumber = num;

            this.userListRequest()
        },


    },
    mounted() {

        this.handleSearch();
        this.getRoleList();
    },

}
</script>

<style scoped>
.hotel-main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 30px 0px rgba(22, 115, 255, 0.1);
}
</style>
